import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ExportHistoryTable from './table/ExportHistoryTable'
import ExportsLoader from './_load/ExportsLoader'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'

const ExportHistoryModal = props => {
  return (
    <ControlledModal width="48rem" {...props}>
      <ModalHeader />
      <Separator weight={4} />
      <FilterHandler>
        <ExportsLoader>
          <ExportHistoryTable />
        </ExportsLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default ExportHistoryModal
